"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineEnvConfigService = defineEnvConfigService;
const EnvConfigServiceV1_1 = require("./v1/EnvConfigServiceV1");
function defineEnvConfigService(options) {
    return {
        id: 'audi:envConfigService',
        optionalDependencies: {
            featureServices: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                's2:logger': '^1.0.0',
            },
        },
        create: (env) => {
            const logger = env.featureServices['s2:logger'] || console;
            const envConfigServiceV1 = new EnvConfigServiceV1_1.EnvConfigServiceV1Impl(options, logger);
            return {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                '1.0.0': () => ({ featureService: envConfigServiceV1 }),
            };
        },
    };
}
//# sourceMappingURL=EnvConfigService.js.map